import type { LucideIcon } from 'lucide-react';
import { cn } from '@/lib/utils';

export interface SectionHeaderProps {
  icon: LucideIcon;
  title: string;
  /** Sobrescreve as margens padrão (ex.: `mt-8` para blocos mais espaçados). */
  className?: string;
}

// Cabeçalho de seção ARA: ícone mono + micro-label maiúsculo + hairline que
// preenche a largura restante. Separa blocos numa ficha sem peso visual —
// usado no cadastro do cliente e no detalhe do imóvel.
export function SectionHeader({ icon: Icon, title, className }: SectionHeaderProps) {
  return (
    <div className={cn('mb-4 mt-6 flex items-center gap-2.5 first:mt-0', className)}>
      <Icon size={14} strokeWidth={1.5} className="shrink-0 text-text-muted" />
      <span className="text-[11px] font-medium uppercase tracking-wide text-text-muted">
        {title}
      </span>
      <span className="h-px flex-1 bg-border" />
    </div>
  );
}
